<template>
    <div>
        <div class="listing">
            <div class="listing__nav">
                <div class="container">
                    <div class="row">
                        <div class="filter-wrap kdgjkfg">

                            <form class="form-inline">
                                <div class="col-lg-2 col-sm-12 col-md-4">
                                    <div class="form-group">
                                        <label>Search</label><br>
                                        <input type="text" v-model="search" class="form-control" @input="searchData">
                                    </div>
                                </div>

                            </form>

                        </div>
                        <div class="col-sm-12">
                            <div class="table-wrap table-responsive">
                                <table class="table table-bordered table-hover table-condensed-xs" cellspacing="0"
                                       cellpadding="0">
                                    <thead>
                                    <tr>
                                        <!--<th scope="col"><input type="checkbox" value=""></th>-->
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Created At</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="users.length == 0">No Record Found</tr>
                                    <tr v-for="user in users.data">

                                        <td>{{user.name}}</td>
                                        <td>{{user.email}}</td>
                                        <td>{{user.created_at}}</td>
                                        <td>{{ user.email_verified_at ? 'Password Created' : 'Registerd' }}</td>
                                        <td>
                                            <div class="btn-group">
                                                <a class="btn btn-xs btn-default dropdown-toggle fa fa-caret-down"
                                                   data-toggle="dropdown" href="#"></a>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                        <a href="#" v-on:click="showModal(user.id,user)"><i
                                                                class="fa fa-info"></i> Detail</a>
                                                    </li>
                                                    <li>
                                                        <a href="#" v-on:click="deleteUser(user.id)"><i
                                                                class="fa fa-trash"></i>
                                                            Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <pagination :data="users" @pagination-change-page="getResults"
                                            :limit="-1"></pagination>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="modal fade in user-detail" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="myModalLabel"> {{user.name}}</h4>
                        <p> Date: {{user.created_at}}</p>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <dl class="des-list">
                                    <dt class="label-value">User Info</dt>
                                    <dt v-if="user.name">Name</dt>
                                    <dd>{{user.name}}</dd>
                                    <dt v-if="user.email">Email</dt>
                                    <dd>{{user.email}}</dd>
                                    <dt v-if="user.company">Company</dt>
                                    <dd>{{user.company}}</dd>
                                    <dt v-if="user.customer_id">Customer Id</dt>
                                    <dd>{{user.customer_id}}</dd>
                                    <dt v-if="user.name">Email Verified</dt>
                                    <dd>{{ user.email_verified_at ? user.email_verified_at : 'No' }}</dd>
                                    <dt v-if="user.plain_password">Password</dt>
                                    <dd>{{ user.plain_password }}</dd>
                                </dl>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import axios from 'axios'

    import VueSweetalert2 from 'vue-sweetalert2';

    Vue.use(VueSweetalert2);

    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';


    Vue.component('pagination', require('laravel-vue-pagination'));
    export default {
        components: {},
        data: function () {
            return {
                users: [],
                user: {},
                search: null,
                password: '',
            }
        },
        methods: {
            getData() {
                let that = this;

                axios.get(that.url + '/users')
                    .then(function (response) {
                        that.users = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });
            },
            showModal(id, user) {
                console.log(id);
                $("#myModal").modal('show');
                let that = this;
                axios.get(that.url + '/users/' + id)
                    .then(function (response) {
                        that.user = user;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {

                    });
            },

            updatePassword(id) {

                let that = this;
                axios.post(that.url + '/update-password', {
                    password: that.password,
                    id: id,
                })
                    .then(function (response) {
                        Vue.$toast.open({
                            message: response.data,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })


                    })
                    .catch(function (error) {
                        that.formErrors = error.response.data.errors || {};

                    });
            },
            deleteUser(id) {

                let that = this;

                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        let t = this;
                        axios.delete(that.url + '/users/' + id)
                            .then(function (response) {
                                t.getData();

                                Vue.$toast.open({
                                    message: response.data,
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })


                                console.log(response.data);

                            })
                            .catch(function (error) {
                                this.$swal('Cancelled', 'Some error found', 'info')
                                console.log(error);
                            })
                            .then(function () {
                            });
                    } else {

                    }
                })


            },
            searchData(data) {
                console.log(data);
                let that = this;
                axios.get(that.url + '/user-search/' + that.search)
                    .then(function (response) {
                        that.users = response.data;
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    });

            },
            getResults(page) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                let that = this;

                axios.get(that.url + '/users?page=' + page)
                    .then(function (response) {
                        that.users = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                    });

            },

        },
        mounted: function () {
            this.getData();
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            mainUrl: function () {
                return process.env.MIX_MAIN_URL;
            }
        }
    }

</script>
